import { connect } from 'react-redux'
import LaunchFrame from '../../components/LaunchFrame'
import { actionProcessSetProgress } from '../../actions'

export function mapStateToProps({ servers, users, processes }, ownProps) {
    const server = servers.list[servers.active]
    const user = users.list[server.shortName][ownProps.userKey]
    let progress
    try {
        progress = processes[server.shortName][user.username].progress
        if (progress === undefined) progress = 0
    } catch (error) {
        progress = 0
    }

    return {
        server,
        user,
        progress,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setClientLaunchProgress: (server, userKey, progress) => {
            dispatch(actionProcessSetProgress(server, userKey, progress))
        },
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    const { user, server, userKey, ...extraProps } = ownProps
    return {
        ...extraProps,
        server: stateProps.server,
        user: stateProps.user,
        setClientLaunchProgress: (progress) => {
            dispatchProps.setClientLaunchProgress(
                stateProps.server.shortName,
                stateProps.user.username,
                progress,
            )
        },
        progress: stateProps.progress,
    }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(LaunchFrame)



// WEBPACK FOOTER //
// ./src/containers/LaunchFrame/launch-frame.js